import { render } from "./CatSelect.vue?vue&type=template&id=494efd9d&scoped=true"
import script from "./CatSelect.vue?vue&type=script&lang=js"
export * from "./CatSelect.vue?vue&type=script&lang=js"

import "./CatSelect.vue?vue&type=style&index=0&id=494efd9d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\pc07\\Documents\\GitHub\\lezione-online-test\\gatthotel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494efd9d"]])

export default __exports__